"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventResultType = exports.getEventName = void 0;
var eventDataById = {
    '333': { resultType: 'time', name: '3x3x3 Cube' },
    '222': { resultType: 'time', name: '2x2x2 Cube' },
    '444': { resultType: 'time', name: '4x4x4 Cube' },
    '555': { resultType: 'time', name: '5x5x5 Cube' },
    '666': { resultType: 'time', name: '6x6x6 Cube' },
    '777': { resultType: 'time', name: '7x7x7 Cube' },
    '333bf': { resultType: 'time', name: '3x3x3 Blindfolded' },
    '333fm': { resultType: 'number', name: '3x3x3 Fewest Moves' },
    '333oh': { resultType: 'time', name: '3x3x3 One-Handed' },
    '333ft': { resultType: 'time', name: '3x3x3 With Feet' },
    minx: { resultType: 'time', name: 'Megaminx' },
    pyram: { resultType: 'time', name: 'Pyraminx' },
    clock: { resultType: 'time', name: 'Clock' },
    skewb: { resultType: 'time', name: 'Skewb' },
    sq1: { resultType: 'time', name: 'Square-1' },
    '444bf': { resultType: 'time', name: '4x4x4 Blindfolded' },
    '555bf': { resultType: 'time', name: '5x5x5 Blindfolded' },
    '333mbf': { resultType: 'multi', name: '3x3x3 Multi-Blind' },
    magic: { resultType: 'time', name: 'Magic' },
    mmagic: { resultType: 'time', name: 'Master Magic' },
    '333mbo': { resultType: 'multi', name: '3x3x3 Multi-Blind Old Style' },
};
function getEventName(eventId) {
    return eventDataById[eventId].name;
}
exports.getEventName = getEventName;
function getEventResultType(eventId) {
    return eventDataById[eventId].resultType;
}
exports.getEventResultType = getEventResultType;
//# sourceMappingURL=event.js.map